// customerMenu.tsx
import {
  DashboardOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  CarOutlined,
  BulbOutlined,
  WechatOutlined,
  ApartmentOutlined,
  DatabaseOutlined,
  TagOutlined,
  RobotOutlined,
  SafetyOutlined,
  UserOutlined,
  SettingOutlined,
  FileOutlined,
  PieChartOutlined,
  BarChartOutlined,
  EnvironmentOutlined,
  BookOutlined,
  FolderOpenOutlined,
  PhoneOutlined,
} from "@ant-design/icons";

interface MenuItem {
  key: string;
  label: string;
  icon?: string;
  permCode?: string;
  path?: string;
  active?: (pathname: string) => boolean;
  external?: boolean;
  children?: MenuItem[];
}

export const menuItems: MenuItem[] = [
  {
    key: "client",
    label: "C端管理",
    children: [
      {
        key: "workbench",
        icon: "DashboardOutlined",
        label: "工作台",
        children: [
          {
            key: "/pages/workbench/pending",
            label: "待我处理",
            path: "/pages/workbench/pending",
          },
          {
            key: "/pages/workbench/info",
            label: "数据看板",
            path: "/pages/workbench/info",
          },
        ],
      },
      {
        key: "/pages/leads",
        icon: "UserSwitchOutlined",
        label: "线索",
        permCode: "service:clue:read",
        path: "/pages/leads",
      },
      {
        key: "/pages/customers",
        icon: "TeamOutlined",
        label: "客户",
        permCode: "service:customer:read",
        path: "/pages/customers",
      },
      {
        key: "/pages/vehicles",
        icon: "CarOutlined",
        label: "车辆",
        permCode: "service:car:read",
        path: "/pages/vehicles",
      },
      {
        key: "/pages/call-center",
        icon: "PhoneOutlined",
        label: "通信助手",
        permCode: "service:call:read",
        path: "/pages/call-center",
        active: (pathname: string) =>
          pathname === "/pages/call-center" ||
          pathname.startsWith("/pages/call-center"),
      },
      {
        key: "opportunities-group",
        icon: "BulbOutlined",
        label: "商机任务",
        permCode: "service:bis:task:read",
        children: [
          {
            key: "/pages/opportunities",
            label: "任务列表",
            path: "/pages/opportunities",
            active: (pathname: string) =>
                pathname === "/pages/opportunities" ||
                (pathname.startsWith("/pages/opportunities/") &&
                    !pathname.startsWith("/pages/opportunities/plans")),
          },
          {
            key: "/pages/opportunities/plans",
            label: "计划列表",
            path: "/pages/opportunities/plans",
            active: (pathname: string) =>
                pathname.startsWith("/pages/opportunities/plans"),
          },
        ],
      },
      {
        key: "/pages/weCom",
        permCode: "service:wechat:read",
        icon: "WechatOutlined",
        label: "企微",
        children: [
          {
            key: "/pages/weCom/friends",
            label: "企微好友",
            path: "/pages/weCom/friends",
          },
        ],
      },
      {
        key: "contract-group",
        icon: "FileOutlined",
        label: "合同",
        permCode: "service:contract:read",
        children: [
          { key: "/pages/contracts", label: "合同管理", path: "/pages/contracts" },
          {
            key: "/pages/contracts/templates",
            label: "模板管理",
            permCode: "service:contract:template:read",
            path: "/pages/contracts/templates",
          },
          {
            key: "/pages/seals",
            label: "印章管理",
            permCode: "service:contract:seal:read",
            path: "/pages/seals",
          },
          {
            key: "esign-console",
            label: "E签宝控制台",
            external: true,
            path: "https://web.esign.cn/workspace/home",
          },
        ],
      },
      {
        key: "document-group",
        icon: "FolderOpenOutlined",
        label: "文档",
        children: [
          {
            key: "/pages/knowledge-base",
            label: "知识库",
            permCode: "service:knowledge:read",
            path: "/pages/knowledge-base",
          },
          {
            key: "/pages/enterprise-db",
            label: "企业数据库",
            permCode: "service:enterprise-db:read",
            path: "/pages/enterprise-db",
          },
        ],
      },
    ],
  },
  {
    key: "admin",
    label: "B端管理",
    children: [
      {
        key: "/admin/workbench/info",
        icon: "PieChartOutlined",
        label: "管理看板",
        permCode: "admin:data:board:read",
        path: "/admin/workbench/info",
      },
      {
        key: "/admin/report",
        icon: "BarChartOutlined",
        label: "数据报表",
        permCode: "admin:report:read",
        children: [
          {
            key: "/admin/report/opportunity",
            label: "商机报表",
            path: "/admin/report/opportunity",
            active: (pathname: string) =>
                pathname === "/admin/report/opportunity",
          },
          {
            key: "/admin/report/statistics",
            label: "数据统计报表",
            path: "/admin/report/statistics",
            permCode: "admin:report:statistics:read",
            active: (pathname: string) =>
                pathname === "/admin/report/statistics",
          },
        ],
      },
      {
        key: "/admin/business-model",
        icon: "ApartmentOutlined",
        label: "业务模型",
        permCode: "admin:business:model:data:read",
        children: [
          {
            key: "/admin/business-model/opportunity-rules",
            label: "商机规则",
            path: "/admin/business-model/opportunity-rules",
          },
          {
            key: "/admin/business-model/task",
            label: "标准任务流",
            path: "/admin/business-model/task",
            active: (pathname: string) =>
                pathname === "/admin/business-model/task" ||
                pathname.startsWith("/admin/business-model/task"),
          },
          {
            key: "/admin/business-model/plan",
            label: "计划模板",
            path: "/admin/business-model/plan",
            active: (pathname: string) =>
                pathname === "/admin/business-model/plan" ||
                pathname.startsWith("/admin/business-model/plan"),
          },
        ],
      },
      {
        key: "/admin/data-dictionary",
        icon: "DatabaseOutlined",
        label: "数据字典",
        permCode: "admin:meta:data:dict:read",
        children: [
          {
            key: "/admin/data-dictionary/leads",
            label: "线索",
            path: "/admin/data-dictionary/leads",
          },
          {
            key: "/admin/data-dictionary/customers",
            label: "客户",
            path: "/admin/data-dictionary/customers",
          },
          {
            key: "/admin/data-dictionary/vehicles",
            label: "车辆",
            path: "/admin/data-dictionary/vehicles",
          },
          {
            key: "/admin/data-dictionary/dict-config",
            label: "字典配置",
            path: "/admin/data-dictionary/dict-config",
          },
        ],
      },
      {
        key: "/admin/car-manage",
        icon: "CarOutlined",
        label: "车辆管理",
        permCode: "admin:car:manage:read",
        children: [
          {
            key: "/admin/car-manage/list",
            label: "车辆列表",
            path: "/admin/car-manage/list",
            active: (pathname: string) =>
                pathname === "/admin/car-manage/list" ||
                pathname.startsWith("/admin/car-manage/upload"),
          },
          {
            key: "/admin/car-manage/spec-template",
            label: "参数模板",
            path: "/admin/car-manage/spec-template",
            permCode: "admin:car:manage:template:read",
          },
          {
            key: "/admin/car-manage/withdrawals",
            label: "推广提现审核",
            path: "/admin/car-manage/withdrawals",
            permCode: "admin:car:manage:read",
          },
        ],
      },
      {
        key: "/admin/tags",
        icon: "TagOutlined",
        label: "标签管理",
        permCode: "admin:tag:mamage:read",
        path: "/admin/tags",
      },
      {
        key: "/admin/roles",
        icon: "SafetyOutlined",
        label: "角色权限",
        permCode: "admin:role:permission:read",
        children: [
          {
            key: "/admin/user/list",
            label: "用户列表",
            path: "/admin/user/list",
          },
          {
            key: "/admin/roles/list",
            label: "角色列表",
            path: "/admin/roles/list",
          },
        ],
      },
      {
        key: "gps-group",
        icon: "EnvironmentOutlined",
        label: "GPS管理",
        permCode: "admin:gps:read",
        children: [
          {
            key: "/admin/gps/monitor",
            label: "GPS监控",
            path: "/admin/gps/monitor",
          },
          {
            key: "/admin/gps/config",
            label: "GPS配置",
            path: "/admin/gps/config",
          },
        ],
      },
    ],
  },
];

export const getAntIcon = (iconName?: string) => {
  const icons = {
    DashboardOutlined: <DashboardOutlined />,
    UserSwitchOutlined: <UserSwitchOutlined />,
    TeamOutlined: <TeamOutlined />,
    CarOutlined: <CarOutlined />,
    BulbOutlined: <BulbOutlined />,
    WechatOutlined: <WechatOutlined />,
    ApartmentOutlined: <ApartmentOutlined />,
    DatabaseOutlined: <DatabaseOutlined />,
    TagOutlined: <TagOutlined />,
    RobotOutlined: <RobotOutlined />,
    SafetyOutlined: <SafetyOutlined />,
    UserOutlined: <UserOutlined />,
    SettingOutlined: <SettingOutlined />,
    FileOutlined: <FileOutlined />,
    PieChartOutlined: <PieChartOutlined />,
    BarChartOutlined: <BarChartOutlined />,
    EnvironmentOutlined: <EnvironmentOutlined />,
    BookOutlined: <BookOutlined />,
    FolderOpenOutlined: <FolderOpenOutlined />,
    PhoneOutlined: <PhoneOutlined />,
  };
  // @ts-ignore
  return icons[iconName] || null;
};
